import { AlertCircle } from "lucide-react";

/**
 * Seção de Problema - Identificação da dor do cliente
 * Mostra as frustrações comuns de profissionais da saúde
 */
export function Problem() {
    // Lista de problemas comuns enfrentados por clínicas
    const problems = [
        {
            title: "Agenda vazia",
            description:
                "Sua agenda está sempre com buracos, sem pacientes suficientes para preencher os horários.",
        },
        {
            title: "Dependência do boca a boca",
            description:
                "Você depende exclusivamente de indicações, sem controle sobre o fluxo de novos pacientes.",
        },
        {
            title: "Sem tempo para marketing",
            description:
                "Você tentou fazer marketing sozinho, mas não tem tempo nem expertise para ter resultados.",
        },
        {
            title: "Gastos sem retorno",
            description:
                "Já investiu em tráfego pago que não converteu, perdendo dinheiro sem trazer pacientes reais.",
        },
    ];

    return (
        <section className="py-20 bg-slate-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* Título da seção */}
                <div className="text-center mb-16">
                    <span className="inline-flex items-center gap-2 text-brand-600 font-semibold mb-4">
                        <AlertCircle className="w-5 h-5" />
                        VOCÊ SE IDENTIFICA?
                    </span>
                    <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
                        A realidade dolorosa da maioria das clínicas
                    </h2>
                    <p className="text-lg text-slate-600 max-w-3xl mx-auto">
                        Você é um excelente profissional, mas a falta de pacientes
                        está te impedindo de crescer. A agenda vazia gera ansiedade
                        e incerteza no futuro do seu negócio.
                    </p>
                </div>

                {/* Grid de problemas */}
                <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
                    {problems.map((problem, index) => (
                        <div
                            key={index}
                            className="bg-white rounded-2xl p-8 shadow-lg border-l-4 border-red-500 hover:shadow-xl transition-shadow duration-300"
                        >
                            <h3 className="text-xl font-bold text-slate-900 mb-3">
                                {problem.title}
                            </h3>
                            <p className="text-slate-600">
                                {problem.description}
                            </p>
                        </div>
                    ))}
                </div>

                {/* Frase de empatia */}
                <div className="mt-16 text-center">
                    <p className="text-xl text-slate-700 font-medium">
                        Se você se identificou com algum desses pontos, saiba que{" "}
                        <span className="text-brand-600 font-bold">
                            existe uma solução
                        </span>{" "}
                        para transformar sua clínica.
                    </p>
                </div>
            </div>
        </section>
    );
}
